var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminDashboardIconOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5232 9.75272C20.8841 5.81932 17.5431 2.89308 13.5598 2.77789C13.3704 2.77047 13.1858 2.83866 13.0467 2.96743C12.9077 3.0962 12.8255 3.27499 12.8184 3.46439V3.46439V3.52846L13.2669 10.2378C13.2963 10.6895 13.6846 11.0328 14.1364 11.0067L20.8641 10.5582C21.0537 10.5442 21.2298 10.4552 21.3536 10.3108C21.4773 10.1665 21.5383 9.97882 21.5232 9.78933V9.75272Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90102 6.76779C9.32898 6.6688 9.76692 6.88777 9.9445 7.28953C9.99102 7.38403 10.019 7.48656 10.0269 7.59159C10.1184 8.89136 10.3106 11.738 10.4205 13.2758C10.4392 13.5528 10.5676 13.8109 10.7772 13.993C10.9868 14.1751 11.2603 14.2662 11.5372 14.2461V14.2461L17.1848 13.8982C17.4369 13.8831 17.6841 13.9728 17.8678 14.1461C18.0515 14.3194 18.1555 14.561 18.155 14.8136V14.8136C17.9262 18.2239 15.4759 21.075 12.1387 21.814C8.80153 22.553 5.37669 21.003 3.7294 18.0081C3.23765 17.1461 2.92623 16.1932 2.81406 15.2072C2.76611 14.9045 2.74772 14.598 2.75914 14.2918C2.76886 10.6498 5.32665 7.51175 8.89187 6.76779",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminDashboardIconOutline);
export default __webpack_public_path__ + "static/media/admin-dashboard-icon-outline.936cc78b828719b881f29716f90af01f.svg";
export { ForwardRef as ReactComponent };